var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPortfolioMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.667 0.666748H3.33366C2.00033 0.666748 0.666992 1.86675 0.666992 3.33341V7.34675C0.666992 8.30675 1.24033 9.13341 2.00033 9.60008V24.6667C2.00033 26.1334 3.46699 27.3334 4.66699 27.3334H23.3337C24.5337 27.3334 26.0003 26.1334 26.0003 24.6667V9.60008C26.7603 9.13341 27.3337 8.30675 27.3337 7.34675V3.33341C27.3337 1.86675 26.0003 0.666748 24.667 0.666748ZM23.3337 24.6667H4.66699V10.0001H23.3337V24.6667ZM24.667 7.33341H3.33366V3.33341H24.667V7.33341Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0003 14.0001H10.0003V16.6667H18.0003V14.0001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPortfolioMenu);
export default __webpack_public_path__ + "static/media/icon_portfolio_menu.6495a78846d24074ec01100980da25d9.svg";
export { ForwardRef as ReactComponent };